var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-br-angle-small-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1721 15.75L19.9789 11.164C20.2737 10.8826 20.4393 10.501 20.4392 10.1032C20.4391 9.70533 20.2734 9.3238 19.9784 9.04254C19.6835 8.76128 19.2835 8.60332 18.8665 8.60342C18.4494 8.60351 18.0495 8.76165 17.7547 9.04304L12.9489 13.629C12.9003 13.6756 12.8424 13.7125 12.7787 13.7377C12.7151 13.763 12.6468 13.7759 12.5779 13.7759C12.509 13.7759 12.4407 13.763 12.377 13.7377C12.3134 13.7125 12.2555 13.6756 12.2068 13.629L7.40103 9.04304C7.10622 8.76165 6.70632 8.60351 6.2893 8.60342C5.87229 8.60332 5.47231 8.76128 5.17736 9.04254C4.88242 9.3238 4.71666 9.70533 4.71656 10.1032C4.71646 10.501 4.88203 10.8826 5.17684 11.164L9.98369 15.75C10.6724 16.4053 11.6053 16.7732 12.5779 16.7732C13.5505 16.7732 14.4834 16.4053 15.1721 15.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.5c0e9aff1a3bf62b5d7cb298fc17e5fa.svg";
export { ForwardRef as ReactComponent };